import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Home } from './pages/Home';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Settings } from './pages/Settings';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Footer } from './components/common/Footer';
import { Navbar } from './components/layout/Navbar';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { PhoneNumberModal } from './components/auth/PhoneNumberModal';
import CookieConsent from './components/common/CookieConsent';
import { useAuth } from './contexts/AuthContext';
import { SubscriptionProvider, useSubscription } from './contexts/SubscriptionContext';

export const App: React.FC = () => {
  const { user } = useAuth();
  const { showUpgradeModal, tier } = useSubscription();
  const location = useLocation();
  const showPhoneModal = user && !user.country && location.pathname !== '/login';

  return (
    <SubscriptionProvider>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow container mx-auto px-4">
          <div className="relative pt-2 pb-6">
            <div className="flex items-center text-sm justify-end mb-4">
              {user && (
                tier === 'FREE' ? (
                  <>
                    <span className="text-gray-600">FREE member</span>
                    <button 
                      onClick={() => showUpgradeModal()}
                      className="ml-2 text-blue-600 hover:text-blue-700 hover:underline"
                    >
                      upgrade now
                    </button>
                  </>
                ) : (
                  <>
                    <span className="text-gray-600">{tier} member</span>
                  </>
                )
              )}
            </div>
            <Routes>
              <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/settings/subscription" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
            </Routes>
          </div>
        </main>
        <Footer />
        {showPhoneModal && <PhoneNumberModal />}
        <CookieConsent />
      </div>
    </SubscriptionProvider>
  );
};